module.exports = __webpack_public_path__ + "img/donut.8ca994f7.svg";